import { IGetContasPagarAnaliticoFiltrosUseCase } from "../../../presentation/useCases/read/get_contas_pagar_analitico_filtros_use_case";
import { ContasPagarAnaliticoFilter } from "../../models/contas_pagar_analitico_filter";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContasPagarAnaliticoFiltrosUseCase
 */

export class GetContasPagarAnaliticoFiltrosUseCase implements IGetContasPagarAnaliticoFiltrosUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(): Promise<ContasPagarAnaliticoFilter | null> {
    return await this.repository.getContasPagarAnaliticoFiltros();

  }
}
